import { AuthRoutes } from './Auth.routes'

export default [...AuthRoutes]
